import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        text: {},
        settings: {
            assetPath: `/assets/`,
            isIE: false,
            serversBusyTimeoutMs: 25000 // How many ms before a 'servers busy' message should be shown
        },
        global: {
            formIsValid: true, // Do all the inputs have a correct input? This is validated by the browser itself
            showLoader: false,
            isPreview: false,
            isWithinIframe: false, // Surveyfrontend could be used within iframes, for example for the 'website' feature in surveyplatform
            countdownInterval: {}, // Interval used by the countdowngo option
            pageLoadIsAllowed: true,
            disableNavButtons: false,
            errorMessage: ``,
            isRefreshed: false, // The user has refreshed the page
            isMobile: /Android|iPhone|iPad/i.test(navigator.userAgent),
            guidRegExp: new RegExp(/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/),
            nextButtonClicked: false, // The next button has been clicked on this questionpage. This can be useful to trigger things like validation to show
            allowedHtml: {
                allowedTags: ["b", "u", "em", "i", "img", "ul", "ol", "li", "font", "a", "p", "strong", "audio", "video", "br", "hr",
                    "span", "source", "table", "thead", "tbody", "tfoot", "th", "tr", "td", "center",
                    "sup", "sub", "abbr", "div", "h1", "h2", "h3", "h4", "h5"],
                allowedAttributes: {
                    'a': ['href', 'name', 'target'],
                    'img': ['src'],
                    '*': ['style']
                }
            },
        },
        surveyInfo: {
            domain: document.location.origin
        },
        page: undefined // The object that holds all the data for all the questions
    },
    mutations,
    getters,
    actions
});

export default store;